import { render, staticRenderFns } from "./issues.vue?vue&type=template&id=702c4a44&lang=pug&"
import script from "./issues.vue?vue&type=script&lang=js&"
export * from "./issues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports